module.exports = __webpack_public_path__ + "img/xrite-colordesigner-plus.9fb0002e.png";